import React from "react";
import {
	Button,
	Dialog,
	DialogContent,
	DialogActions,
} from "../../../common/MaterialComponent";
import MessageSegmentPreview from "../MessageSegmentPreview/MessageSegmentPreview";
import { useGetComponentStringsContext } from "../../../hooks/useGetComponentStrings";
import Shared from "../../../common/shared";
import Alert from "@material-ui/lab/Alert";

export interface DialogProps {
	open: boolean;
	message: string;
	index?: string;
	country: string;
	closeDialog: Function;
}

const MessageSegmentPreviewDialog = (props: DialogProps) => {
	const sharedStrings = useGetComponentStringsContext().Shared;
	const strings = useGetComponentStringsContext().MessageLanguageRow;
	return (
		<div data-testid="segmentPreviewContainer">
			<Dialog open={props.open} fullWidth>
				<DialogContent dividers>
					<MessageSegmentPreview
						index={props.index ? props.index : ""}
						messageContent={props.message}
						textDirection=""
						country={props.country}
					/>
					{(Shared.messageDynamicVariables(
						undefined,
						undefined,
						props.message
					) ||
						Shared.messageHasVariables(
							undefined,
							undefined,
							props.message
						)) && (
						<>
							<br />
							<Alert severity="info" variant="outlined">
								{strings.variablesMessageSegmentWarning}
							</Alert>
						</>
					)}
				</DialogContent>
				<DialogActions>
					<Button onClick={() => props.closeDialog()} className="cancelBtn">
						{sharedStrings.closeButtonText}
					</Button>
				</DialogActions>
			</Dialog>
		</div>
	);
};
export default MessageSegmentPreviewDialog;
